import * as React from 'react';
import { Component } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { __, mapStateToProps } from '../../core/utils';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import Input from '../../components/Input';
import Textarea from '../../components/Textarea';
import Checkbox from '../../components/Checkbox';
import Button from '../../components/Button';
import ButtonGroup from '../../components/ButtonGroup';
import styles from '../../styles/forms/planning_library_item/PlanningLibraryItemForm.scss';

@reduxForm({
  form: 'planning_library_item',
  enableReinitialize: true,
})
@subscribe(Localization, 'localization')
@mapStateToProps((state) => ({
  application_language_id: state.auth.language_id,
}))
class PlanningLibraryItemForm extends Component {
  render() {
    const application_languages = _.transform(
      _.filter(
        this.props.localization.languages,
        (language) => language.application_language == true
      ),
      (languages, language) => {
        languages[language.id] =
          language.id == this.props.application_language_id;

        return languages;
      },
      {}
    );

    return (
      <Form className={styles.wrapper} onSubmit={this.props.handleSubmit}>
        <header className={styles.header}>
          <span className={styles.title}>{this.props.title}</span>
          <span className={styles.subtitle}>
            {__('planning-templates.editor.subtitle')}
          </span>
        </header>

        <div className={styles.form}>
          <Field
            name='name'
            component={Input}
            localized={application_languages}
            label={__('planning-templates.editor.name')}
          />
          <Field
            name='code'
            component={Input}
            label={__('planning-templates.editor.code')}
            maxLength={100}
          />
          <Field
            name='description'
            component={Textarea}
            localized={application_languages}
            label={__('planning-templates.editor.description')}
            rows={3}
            maxRows={4}
          />
          <Field
            name='active'
            component={Checkbox}
            blue
            label={__('planning-templates.editor.active')}
          />
        </div>

        <footer className={styles.footer}>
          <Button
            lightGray
            medium
            middleText={__('button.cancel')}
            onClick={this.props.onClose}
          />
          <ButtonGroup>
            <Button
              submit
              lightBlue
              medium
              middleText={
                this.props.editing ? __('button.save') : __('button.create')
              }
              spinning={this.props.submitting}
            />
          </ButtonGroup>
        </footer>
      </Form>
    );
  }
}

export default PlanningLibraryItemForm;
